import { render, staticRenderFns } from "./PartneringCompanies.vue?vue&type=template&id=549f8852"
import script from "./PartneringCompanies.vue?vue&type=script&lang=ts"
export * from "./PartneringCompanies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports